import { StockListResponseType } from "@sellar-io/api-v2/types";
import { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query";

export const updateCompleteQueryList = ({
  currentIndex,
  completedQueryList,
  setCompletedQueryList,
  productsListQuery,
}: {
  currentIndex?: number;
  completedQueryList?: boolean[];
  setCompletedQueryList?: (list: boolean[]) => void;
  productsListQuery: UseInfiniteQueryResult<
    InfiniteData<StockListResponseType>
  >;
}) => {
  if (
    currentIndex !== undefined &&
    productsListQuery.isSuccess &&
    !productsListQuery.hasNextPage &&
    !productsListQuery.isFetching &&
    completedQueryList &&
    !completedQueryList[currentIndex]
  ) {
    const newCompletedList = [...completedQueryList];
    newCompletedList[currentIndex] = true;
    setCompletedQueryList?.(newCompletedList);
    return;
  }
};
